import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CodeHighlightComponent } from '../code-highlight/code-highlight.component';
import { TabFooterComponent } from '../tab-footer/tab-footer.component';
import { ExportedDatasetSourceContent } from '@mode/shared/contract-common';

@Component({
  standalone: true,
  selector: 'mode-export-dataset-view',
  imports: [CodeHighlightComponent, CommonModule, TabFooterComponent],
  templateUrl: './export-dataset-view.component.html',
  styleUrls: ['./export-dataset-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportDatasetViewComponent {
  @Input() exportedDatasetSource: ExportedDatasetSourceContent = {
    cellContent: '',
    executionCount: 0,
  };
}
